import { render, staticRenderFns } from "./ArrowForwardPrimary.vue?vue&type=template&id=520b4bef&scoped=true&"
import script from "./ArrowForwardPrimary.vue?vue&type=script&lang=js&"
export * from "./ArrowForwardPrimary.vue?vue&type=script&lang=js&"
import style0 from "./ArrowForwardPrimary.vue?vue&type=style&index=0&id=520b4bef&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "520b4bef",
  null
  
)

export default component.exports